import { type UseQueryResult, useQuery } from 'react-query';
import { MyHoldingsSharedService } from '../../services/wealthlane-award-services';

const useGetPsuAwardNumber = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const psuAwardNumberOptions = useQuery(
    ['getPsuAwardNumberOptions'],
    async () => {
      return await handleRequest(
        MyHoldingsSharedService.getApiAwardApiAppMyHoldingsPSUAwardNumbers()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.awardNumber ?? '',
            value: item.psuAwardId ?? '',
          };
        });
      },
    }
  );

  return psuAwardNumberOptions;
};

export default useGetPsuAwardNumber;
